import React from 'react';
import { FilterSelect } from '../../../shared/table/FilterSelect';

export const DashboardTicketsFiltersDrawer = ({
    isOpen,
    onClose,
    days,
    quickRangeOptions,
    onDaysChange,
    dateFrom,
    dateTo,
    onDateFromChange,
    onDateToChange,
    status,
    statusOptions,
    onStatusChange,
    priority,
    priorityOptions,
    onPriorityChange,
    type,
    typeOptions,
    onTypeChange,
    source,
    sourceOptions,
    onSourceChange,
    assigneeId,
    assigneeOptions,
    onAssigneeChange,
    slaMode,
    slaModeOptions,
    onSlaModeChange,
    onApply,
    onClear,
    isLoading,
}) => {
    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="ticket-filters-drawer-overlay" onClick={onClose}>
            <aside className="ticket-filters-drawer" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label="Filtros de dashboard de tickets">
                <div className="ticket-filters-drawer__header">
                    <div>
                        <h6 className="mb-0 fw-bold">Filtros de tickets</h6>
                    </div>
                    <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
                        <i className="feather-x" />
                    </button>
                </div>

                <div className="ticket-filters-drawer__body">
                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Rango rápido</label>
                        <FilterSelect
                            value={days}
                            options={quickRangeOptions}
                            onChange={(nextValue) => onDaysChange(Number(nextValue || 30))}
                            placeholder="Rango"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Desde</label>
                        <div className="dashboard-date-input">
                            <input
                                type="date"
                                className="form-control form-control-sm dashboard-date-input__control"
                                value={dateFrom}
                                onChange={(event) => onDateFromChange(event.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Hasta</label>
                        <div className="dashboard-date-input">
                            <input
                                type="date"
                                className="form-control form-control-sm dashboard-date-input__control"
                                value={dateTo}
                                onChange={(event) => onDateToChange(event.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Estatus</label>
                        <FilterSelect
                            value={status}
                            options={statusOptions}
                            onChange={(nextValue) => onStatusChange(nextValue || '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Prioridad</label>
                        <FilterSelect
                            value={priority}
                            options={priorityOptions}
                            onChange={(nextValue) => onPriorityChange(nextValue || '')}
                            placeholder="Todas"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Tipo</label>
                        <FilterSelect
                            value={type}
                            options={typeOptions}
                            onChange={(nextValue) => onTypeChange(nextValue || '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Origen</label>
                        <FilterSelect
                            value={source}
                            options={sourceOptions}
                            onChange={(nextValue) => onSourceChange(nextValue || '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Responsable</label>
                        <FilterSelect
                            value={assigneeId}
                            options={assigneeOptions}
                            onChange={(nextValue) => onAssigneeChange(nextValue || '')}
                            placeholder="Todos"
                            searchable
                            searchPlaceholder="Buscar responsable..."
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">SLA</label>
                        <FilterSelect
                            value={slaMode}
                            options={slaModeOptions}
                            onChange={(nextValue) => onSlaModeChange(nextValue || '')}
                            placeholder="Todos"
                        />
                    </div>
                </div>

                <div className="ticket-filters-drawer__footer d-flex gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-secondary w-100"
                        onClick={onClear}
                        disabled={isLoading}
                    >
                        Limpiar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={() => {
                            onApply();
                            onClose();
                        }}
                        disabled={isLoading}
                    >
                        Aplicar
                    </button>
                </div>
            </aside>
        </div>
    );
};
